import api from '@pray/shared/utils/api';

export type SystemCheckLeadValidationArtist = {
  artist_id: string;
  artist_name: string;
  stuck_leads: number;
  affected_lists: number;
  oldest_stuck: string | null;
  newest_stuck: string | null;
};

export type SystemCheckLeadValidationResponse = {
  data: {
    artists: SystemCheckLeadValidationArtist[];
    next_cursor: string | null;
  };
};

export type GetSystemCheckLeadValidationParams = {
  cursor?: string | null;
  limit?: number;
};

export async function getSystemCheckLeadValidation({
  cursor = null,
  limit = 50,
}: GetSystemCheckLeadValidationParams = {}): Promise<SystemCheckLeadValidationResponse> {
  const params: Record<string, string | number> = { limit };

  if (cursor) params.cursor = cursor;

  const url = '/web/studio/system-check/lead-validation';
  const response = await api.executeGetRequest<{ data: SystemCheckLeadValidationResponse }>(url, params);

  return response.data.data;
}
